<template>
    <div>
        <h5>
            {{ progress }}%
        </h5>
    </div>
</template>

<script>
import store from '@/store'

export default {
    computed: {
        progress() {
            return store.state.currentProgress
        }
    }
}
</script>

<style scoped>
    h5 {
        padding: 0;
        margin: 15px 0 0 0;
        text-align: center;
    }
</style>
